var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailerParking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42969 4.33997V15.22",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81055 4.33997V15.22",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1895 4.33997V15.22",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5703 4.33997V15.22",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00961 22.31C5.06447 22.31 5.91961 21.4549 5.91961 20.4C5.91961 19.3451 5.06447 18.49 4.00961 18.49C2.95475 18.49 2.09961 19.3451 2.09961 20.4C2.09961 21.4549 2.95475 22.31 4.00961 22.31Z",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77914 22.31C9.834 22.31 10.6891 21.4549 10.6891 20.4C10.6891 19.3451 9.834 18.49 8.77914 18.49C7.72428 18.49 6.86914 19.3451 6.86914 20.4C6.86914 21.4549 7.72428 22.31 8.77914 22.31Z",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 1.85999H1.5V17.87H22.5V1.85999Z",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9902 18.11L21.9502 21.93",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9492 18.11V23.1",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerParking);
export default __webpack_public_path__ + "static/media/trailer-parking.cf475378.svg";
export { ForwardRef as ReactComponent };